// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"68":"97b0f13b","366":"b9466c13","2042":"45d90c08","7073":"f45dd539","7557":"168b4d7a","8703":"a411638d"}[chunkId] + ".chunk.css";
};